export const GITHUB_PAGE_URL = process.env.REACT_APP_GITHUB_URL;
export const TWITTER_PAGE_URL = process.env.REACT_APP_TWITTER_URL;
export const LINKEDIN_PAGE_URL = process.env.REACT_APP_LINKEDIN_URL;
export const MAIL_ADDRESS = process.env.REACT_APP_MAIL_ADDRESS;
export const PROFILE_IMAGE_URL = process.env.REACT_APP_PROFILE_IMAGE_URL;
export const HERO_TEXT = process.env.REACT_APP_HERO_TEXT;
export const HERO_SECONDARY_TEXT = process.env.REACT_APP_HERO_SECONDARY_TEXT;
